import { render, staticRenderFns } from "./LevelView.vue?vue&type=template&id=34c61d6c&scoped=true"
import script from "./LevelView.vue?vue&type=script&lang=js"
export * from "./LevelView.vue?vue&type=script&lang=js"
import style0 from "./LevelView.vue?vue&type=style&index=0&id=34c61d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c61d6c",
  null
  
)

export default component.exports